import http from '../interceptors/Intercepter';

export const retrieveForms = async (username) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.get('/api/form/viewAll', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const createForm = async (username, form) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.post('/api/form/create', form, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewForm = async (username, formExternalReference) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
      params: {
        username: username,
        formExternalReference: formExternalReference,
      },
    };

    const { data } = await http.post('/api/form/retrieve', null, config);

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateForm = async (username, formVo) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.post('/api/form/update', formVo, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const deleteForm = async (username, formToDelete) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.post('/api/form/delete', formToDelete, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveFormsForVisits = async (username) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.get('/api/form/viewAllGeneral', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveFormsWithVisitCodes = async (username, studyExternalReference) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      studyExternalReference: studyExternalReference,
      username: username,
    };

    const { data } = await http.get('/api/form/view/changeVisit', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
